// extracted by mini-css-extract-plugin
module.exports = {"topicbox":"TopicBox_topicbox__4wp77","wrapper":"TopicBox_wrapper__oOKLr"};